<template>
    <v-app id="inspire" >
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex sm6>
                        <v-card class="elevation-12" max-width="500px">
                            
                            <v-card-text>
                                <v-alert
                                    :value="!checkCookieEnabled"
                                    color="error"
                                    icon="cookie"
                                    outline
                                >Sua navegação em Nhafatura requer cookies habilitados. Por favor habilite os cookies no seu navegador.
                                </v-alert>

                                <v-alert
                                    :value="showEmailSentAlert"
                                    color="info"
                                    icon="info"
                                    outline
                                >Foi enviado um email com as instruções a seguir para alterar a sua senha.
                                </v-alert>
                                <v-layout row>
                                    <v-flex grow> </v-flex>
                                    <v-flex shrink>
                                        <v-img src="/images/nha_fatura.png" style="width: 80px"></v-img>
                                    </v-flex>
                                    <v-flex grow>  </v-flex>
                                </v-layout>

                                <v-form>
                                    <v-text-field prepend-icon="person"
                                          label="Email"
                                          type="email"
                                          v-model="username"
                                          :error-messages="emailErrors"
                                          @blur="$v.username.$touch()"></v-text-field>
                                    <v-text-field v-model="password"
                                          prepend-icon="lock"
                                          label="Senha"
                                          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                          :type="showPassword ? 'text' : 'password'"
                                          @click:append="showPassword = !showPassword"
                                          @keyup.enter="login"
                                          :error-messages="passwordErrors"
                                          @blur="$v.password.$touch()"></v-text-field>
                                </v-form>
                                <v-layout row>
                                    <v-flex grow> </v-flex>
                                    <v-flex shrink style="margin-right: -10px">
                                        <v-btn flat small :loading="forgotPasswordLoading" color="primary" @click="forgotPassword()">Esqueci minha senha</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn color="primary" block
                                       :loading="loading"
                                   :disabled="loading || $v.$invalid"
                                   @click="login">Entrar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import Vue from 'vue';
    import {email, required} from 'vuelidate/lib/validators'
    import {mapGetters} from 'vuex';
    export default {
        data(){
            return{
                loading: false,
                showPassword: false,
                username: '',
                password: '',
                forgotPasswordLoading: false,
                showEmailSentAlert: false,
            }
        },
        validations: {
            username: {
                email,
                required,
            },
            password: {
                required,
            },

        },
        computed:{
            ...mapGetters([
                'loggedIn',
            ]),
            checkCookieEnabled (){
                return navigator.cookieEnabled;
            },
            loadWorkplace:{
                get(){
                    return this.$store.getters.loadWorkplace;
                },
                set(value){
                    this.$store.dispatch('loadWorkplace', value);
                }
            },
            emailErrors () {
                const errors = [];
                if (!this.$v.username.$dirty) return errors;
                !this.$v.username.email && errors.push('Introduza um email válido');
                !this.$v.username.required && errors.push('Introduza seu email');
                return errors
            },
            passwordErrors(){
                const errors = [];
                if (!this.$v.password.$dirty) return errors;
                !this.$v.password.required && errors.push('Introduza uma senha');
                return errors
            },
        },

        methods:{
            login(){
                if (!navigator.cookieEnabled) {
                    this.showSnackBar('cookies are not enabled', 'error');
                }
                
                try {
                    this.loading = true;
                    this.showEmailSentAlert = false;
                    this.$store.dispatch('login', {
                        email: this.username,
                        password: this.password,
                    }).then(response => {
                        console.log('response:', response);
                        if(response.data.error === 'invalid_credentials') {
                            this.showSnackBar('Email ou senha inválido.', 'error');
                            return;
                        }else if(response.data.response === 'company_no_access'){
                            this.showSnackBar('Sua Empresa não tem acesso para entrar em Nhafatura.', 'info');
                            return;
                        }else if(response.data.response === 'no_access'){
                            this.showSnackBar('Não tens acesso para entrar em Nhafatura.', 'info');
                            return;
                        }else if(response.data.error === 'user_blocked'){
                            let min = response.data.time;
                            this.showSnackBar('Varias tentativas falhadas. Por Favor tente novamente em '+min+' minutos.', 'block');
                            return;
                        }

                        if(response.data.success === true){
                            // this.loadLoggedUserInfos();
                            this.loadWorkplace = true;
                            this.$router.push({ name: 'dashboard' });
                        }

                    }).catch(e => {
                        this.showSnackBar('Ocorreu um erro. Por favor tente mais tarde.', 'error');
                        this.consoleLog(e);
                    }).finally(()=>{
                        this.loading = false;
                    })

                }catch (e) {
                    // Error is handled in the (login auth.js)
                }
            },
            loadLoggedUserInfos(){
                this.consoleLog('loadLoggedUserInfos');
                this.forgotPasswordLoading = true;
                this.$store.dispatch('loggedUserInfos').then(response => {
                    if(!response.data.success){
                        this.showSnackBar('Erro ao carregar as suas informações.', 'error');
                        this.loadWorkplace = false;
                    }
                    this.loadWorkplace = true;
                    this.consoleLog(':::::loadWorkPlace');
                }, error => {
                    this.consoleLog('error:::', error);
                    this.loadWorkplace = false;
                });
            },
            forgotPassword(){
                if(this.$v.username.$invalid){
                    this.$v.username.$touch()
                    this.showSnackBar('Introduza um email válido', 'error');
                    return;
                }
                this.showEmailSentAlert = false;
                this.forgotPasswordLoading = true;
                this.password = ''; //clear password field
                this.$v.password.$reset();
                Vue.axios.post('forgot_password', {
                    email: this.username,
                }).then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        if(response.data.error === 'user_not_found'){
                            this.showSnackBar('Email não encontrado. Verifique e tente novamente.', 'black');
                            return;
                        }
                        return;
                    }
                    // let updatedCompany = response.data.response;
                    this.showEmailSentAlert = true;

                }).catch(error => {
                    this.consoleLog(error);

                }).finally( ()=> {
                    this.forgotPasswordLoading = false;
                });
            },
        }
    }
</script>